import React from 'react';
import {
    GelBoxLayout,
    GelContainerLite,
    GelLabel,
    GelLink} from '@tal-gel/components';
import { getGelTokens } from '@tal-gel/theming';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { AdobeAnalytics } from '../../common/analytics/adobe-analytics';
import { AdobeClickType } from '../../constants/constants';
import Tag from '../../common/components/Tag';
import { useGetHomePageContent } from '../../common/api/graphQLDataFetch';
import { Requirements } from '../../common/models/memberclaims';
import { activeUploadActions } from '../claimdetails/documentsupload/activeUploadStore';

interface RequirementProps {
    requirementList: Requirements[];
    thirdPartyRequirement: string;
    caseNumber: string;
}
const Requirement = (props: RequirementProps) => {
    const { requirementList, thirdPartyRequirement, caseNumber } = props;
    const { global: { sizeNone, sizeBaseX3, themeColorGrayT10, themeColorBackgroundLight, 
        sizeBaseX4, themeColorGrayT20, sizeBaseX2 } } = getGelTokens();
    const { data } = useGetHomePageContent()

    const navigate = useNavigate();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, setClaimCookie] = useCookies(['selectedClaim']);
    const [{ tpid }] = useCookies(["tpid"]);

    const navigateToDetails = (reqId, reqName) => {
        setClaimCookie('selectedClaim', caseNumber);

        AdobeAnalytics.PushClickEvent(tpid, reqName, AdobeClickType.Link)

        navigate("/claimdetails");
        activeUploadActions.startForRequirement(reqId);
    };

    const isPendingRequirement = requirementList?.some(req => !req.completedDate);

    const requirements = isPendingRequirement ?
        requirementList.filter(req => !req.completedDate).map((req, index) =>
            <GelBoxLayout key={req.id} alignmentIndividual={['center', null]} space={[7, 0.1, 0.1]}
                style={{
                    backgroundColor: themeColorBackgroundLight,
                    paddingTop: sizeBaseX3,
                    paddingBottom: sizeBaseX3,
                    paddingLeft: sizeBaseX4,
                    border: `0px solid ${themeColorGrayT10}`,
                    borderWidth: `${index === 0 ? 1 : 0}px 0px 1px`
                }}
                childStyle={{
                    paddingLeft: '0px',
                    paddingRight: '0px'
                }}>
                <GelLink onClick={() => navigateToDetails(req.id, req.friendlyText)}>{req.friendlyText}</GelLink>
                {(req.receivedDate || req.associatedDocuments?.length) &&
                    <Tag text={data?.requirementReviewStatus} status={"warning"}/>
                }
                {!req.receivedDate && !req.associatedDocuments?.length &&
                     <Tag text={data?.requirementInCompleteStatus} status={"danger"}/>
                }
            </GelBoxLayout>
        )
        :
        <GelBoxLayout alignmentIndividual={['center', null]} space={[7, 0.1, 0.1]} style={{
            backgroundColor: themeColorBackgroundLight,
            paddingTop: sizeBaseX3,
            paddingBottom: sizeBaseX3,
            paddingLeft: sizeBaseX3,
            border: `0px solid ${themeColorGrayT20}`,
            borderWidth: `1px 0px 1px`
        }}>
            {!isPendingRequirement && thirdPartyRequirement &&
                <GelLabel>{data?.thirdPartyRequirementStatus}</GelLabel>
            }
            {!isPendingRequirement && !thirdPartyRequirement &&
                <GelLabel>{data?.requirementCompletedStatus}</GelLabel>
            }
        </GelBoxLayout>

    return (
        <GelContainerLite gutter="medium" style={{
            paddingBottom: sizeNone,
            paddingTop: sizeNone,
            paddingLeft: sizeBaseX2,
            paddingRight: sizeBaseX2,
        }}>
            {requirements}
        </GelContainerLite>
    );
};

export default Requirement;